import {createFileRoute} from '@tanstack/react-router';

import PatientTemporaryImagesUpload from '@/practitioner/views/patient/PatientTemporaryImagesUpload';

export const Route = createFileRoute('/(practitioner)/patients/$patientId/temporary-images/upload')(
  {
    component: PatientTemporaryImagesUpload,
    loader: ({params}) => ({
      patientId: params.patientId
    })
  }
);
